import { Instance } from 'mobx-state-tree';
import { RouteOnTheWayToStopDtoModelBase } from './RouteOnTheWayToStopDtoModel.base';

/* The TypeScript type of an instance of RouteOnTheWayToStopDtoModel */
export interface RouteOnTheWayToStopDtoModelType extends Instance<typeof RouteOnTheWayToStopDtoModel.Type> {}

/* A graphql query fragment builders for RouteOnTheWayToStopDtoModel */
export { selectFromRouteOnTheWayToStopDto, routeOnTheWayToStopDtoModelPrimitives, RouteOnTheWayToStopDtoModelSelector } from './RouteOnTheWayToStopDtoModel.base';

/**
 * RouteOnTheWayToStopDtoModel
 *
 * Completed OnTheWayToStop event
 */
export const RouteOnTheWayToStopDtoModel = RouteOnTheWayToStopDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
